export const PRODUCTOS = 'CARRITO_PRODUCTOS'
export const DIRECCIONES = 'CARRITO_DIRECCIONES'
export const PAGOS = 'CARRITO_PAGOS'
export const RESUMEN = 'CARRITO_RESUMEN'
export const FINALIZADO = 'CARRITO_FINALIZ0'
